import React, { useState } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';

/**
 * 젭스 스토리 영상 컴포넌트
 * - ReactPlayer 컴포넌트를 래핑한 컴포넌트
 * - 플레이어가 준비될 때까지 스켈레톤으로 자리를 채운다
 */
export const StoryPlayer = ({ url, ...props }: ReactPlayerProps) => {
  // url 단위로 기억해 영상이 바뀌면 다시 스켈레톤을 덮는다
  const [readyUrl, setReadyUrl] = useState<unknown>();

  return (
    <div className="relative w-full" style={{ aspectRatio: '16/9' }}>
      <ReactPlayer
        width={'100%'}
        height={'100%'}
        url={url}
        {...props}
        onReady={() => setReadyUrl(url)}
      />
      {readyUrl !== url && (
        <div className="absolute inset-0 animate-pulse bg-gray2" />
      )}
    </div>
  );
};
